import {
  CustomInput,
  CustomSelect,
  CustomSlider,
  CustomToggle,
} from '../Components/CustomFormElements';
import { VoiceProfileForm as FormState, VoiceProfileFormProps } from './VoiceProfileHelpers';

function VoiceProfileForm({
  form,
  agents,
  voices,
  isDisabled = false,
  onChange,
}: VoiceProfileFormProps) {
  const set = (partial: Partial<FormState>) => onChange({ ...form, ...partial });

  return (
    <>
      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Name</div>
          <div className="small-font">Enter voice profile name</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomInput
            id="voice-profile-name"
            label="Voice Profile Name"
            placeholder="Enter voice profile name"
            icon={<i className="fa-solid fa-comments"></i>}
            value={form.name}
            onChange={(_, value) => set({ name: value })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Agent</div>
          <div className="small-font">Select an agent</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSelect
            id="agent-select"
            label="Agent"
            placeholder="Select an agent"
            options={agents.map((a) => ({ value: a.key, label: a.name }))}
            value={form.assistantKey}
            multiSelect={false}
            onChange={(value) => set({ assistantKey: value as string })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Voice Type</div>
          <div className="small-font">Select a voice (optional)</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSelect
            id="voice-select"
            label="Voice"
            placeholder="Select a voice"
            options={voices}
            value={form.voice}
            multiSelect={false}
            onChange={(value) => set({ voice: value as string })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Voice Speed</div>
          <div className="small-font">Set voice speed (0.7-1.2)</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSlider
            id="voice-speed-slider"
            label="Voice Speed"
            value={form.voiceSpeed}
            min={0.7}
            max={1.2}
            oneStep={0.1}
            onChange={(value) => set({ voiceSpeed: value })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">VAD Threshold</div>
          <div className="small-font">Set VAD threshold (0.1-0.9)</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSlider
            id="vad-threshold-slider"
            label="VAD Threshold"
            value={form.vadThreshold}
            min={0.1}
            max={0.9}
            oneStep={0.05}
            onChange={(value) => set({ vadThreshold: value })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">VAD Silence</div>
          <div className="small-font">Set VAD silence (0.5-5)</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSlider
            id="vad-silence-slider"
            label="VAD Silence"
            value={form.vadSilence}
            min={0.5}
            max={5}
            oneStep={0.1}
            onChange={(value) => set({ vadSilence: value })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Stability</div>
          <div className="small-font">Set stability (0-1)</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSlider
            id="stability-slider"
            label="Stability"
            value={form.stability}
            min={0}
            max={1}
            oneStep={0.05}
            onChange={(value) => set({ stability: value })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Similarity Boost</div>
          <div className="small-font">Set similarity boost (0-1)</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomSlider
            id="similarity-boost-slider"
            label="Similarity Boost"
            value={form.similarityBoost}
            min={0}
            max={1}
            oneStep={0.05}
            onChange={(value) => set({ similarityBoost: value })}
          />
        </div>
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <div className="input-description">
          <div className="input-title">Activate Voice Profile</div>
          <div className="small-font">Set voice profile to be active or inactive</div>
        </div>
        <div className="align-wrapper d-flex align-center">
          <CustomToggle
            id="toggle-status"
            label={form.isActive ? 'Active' : 'Inactive'}
            checked={form.isActive}
            onChange={(_id: string, checked: boolean) => set({ isActive: checked })}
            disabled={isDisabled}
          />
        </div>
      </div>
    </>
  );
}

export default VoiceProfileForm;
